import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center mb-4">
              <img 
                src="/shared/assets/images/logo/logo.svg" 
                alt="WaitlistPoker Logo" 
                className="h-8 w-auto mr-2"
                onError={(e) => {
                  const target = e.currentTarget;
                  const fallback = target.nextElementSibling as HTMLElement;
                  if (fallback) {
                    target.style.display = 'none';
                    fallback.style.display = 'flex';
                  }
                }}
              />
              <div className="h-8 w-8 bg-primary rounded-lg flex items-center justify-center mr-2 hidden">
                <span className="text-white font-bold text-lg">♠</span>
              </div>
              <span className="text-lg font-bold text-gray-900">WaitlistPoker</span>
            </Link>
            <p className="text-gray-600 text-sm max-w-md">
              Streamline your poker room operations with real-time waitlist management and seat availability notifications.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4">
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/how-it-works" 
                  className="text-gray-600 hover:text-primary text-sm transition-colors duration-200"
                >
                  How It Works
                </Link>
              </li>
              <li>
                <Link 
                  to="/" 
                  className="text-gray-600 hover:text-primary text-sm transition-colors duration-200"
                >
                  Poker Rooms
                </Link>
              </li>
              <li>
                <a 
                  href="https://waitlistpokertournaments.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 hover:text-primary text-sm transition-colors duration-200"
                >
                  Poker Tournament Software
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4">
              Legal
            </h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/terms" 
                  className="text-gray-600 hover:text-primary text-sm transition-colors duration-200"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link 
                  to="/privacy" 
                  className="text-gray-600 hover:text-primary text-sm transition-colors duration-200"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-8 pt-8 border-t border-gray-200">
          <div className="flex flex-col sm:flex-row justify-between items-center">
            <p className="text-gray-500 text-sm">
              © {new Date().getFullYear()} WaitlistPoker. All rights reserved.
            </p>
            <div className="mt-4 sm:mt-0 flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
              {/* App Store Badge with stacked text */}
              <a
                href="https://apps.apple.com/us/app/waitlistpoker/id6754001780"
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-col items-center gap-1 hover:opacity-80 transition-opacity"
              >
                <img
                  src="/images/app-store-apple-logo.svg"
                  alt="Download on the App Store"
                  className="h-6 w-auto"
                />
                <span className="text-gray-600 text-xs">Love WaitlistPoker? Leave us a review!</span>
              </a>
              {/* Contact Support */}
              <a 
                href="mailto:support@pingsolveai.com" 
                className="text-primary hover:text-primary/80 text-sm font-medium transition-colors duration-200"
              >
                Contact Support
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
